import styled from 'styled-components'
import { handleSearchInputSize } from '../mixin'
import { InputContainer } from '../styles'

export const SearchInputContainer = styled(InputContainer)<{
  size?: string
  attach?: null | 'top' | 'left' | 'bottom' | 'right' | 'all'
}>`
  width: 100%;
  position: relative;
  ${({ size }) => handleSearchInputSize(size)};
  display: flex;
  align-items: center;

  input:focus {
    z-index: 20;
    margin-left: -33px;
    padding-left: 35px;
  }
`

export const SearchInputIconWrapper = styled.div`
  margin: 2px 10px 0px;
`
